
<template>
  <div>
    <b-table-simple striped responsive="sm">
      <b-thead>
        <b-th
          >{{
            $getVisibleNames(
              "evaluations.observationachievement",
              false,
              "Niveles de Logro"
            )
          }}
        </b-th>

        <b-th>{{ $t("reusable.common.description") }}</b-th>
        <b-th style="width: 80px">{{
          RubricPreset && RubricPreset.show_percentage_sign
            ? $t("curricularDefinitions.rubricPreset.percentage")
            : $t("curricularDefinitions.rubricPreset.score")
        }}</b-th>
        <b-th v-if="allows_crud" style="width: 30px" class="text-center">
          <ButtonSmall
            v-if="allows_crud"
            :tooltip_text="
              $t('reusable.common.createTooltip', {
                entity: $getVisibleNames(
                  'evaluations.observationachievement',
                  false,
                  'Nivel de Logro'
                ),
              })
            "
            :text_button="``"
            :click_button="
              () =>
                $bvModal.show(
                  `created-rubric_preset_unit-modal-${RubricPreset.id}`
                )
            "
            :icon="'plus'"
            :variant="'none'"
            :custom_class="'text-white'"
          >
          </ButtonSmall>
        </b-th>
      </b-thead>
      <b-tbody>
        <template v-for="rubric_preset_unit in rubricPresetList">
          <b-tr :key="`${RubricPreset.id}-${rubric_preset_unit.id}`">
            <b-td class="pl-3 text-justify align-text-top">
              {{ rubric_preset_unit.title }}
            </b-td>
            <b-td>
              <RenderVHtml
                :content="rubric_preset_unit.description"
              ></RenderVHtml>
            </b-td>
            <b-td>
              {{ rubric_preset_unit.score }}
            </b-td>
            <b-td v-if="allows_crud">
              <div class="d-flex p-1">
                <ButtonSmall
                  :tooltip_text="
                    $t('reusable.common.editTooltip', {
                      entity: $getVisibleNames(
                        'evaluations.observationachievement',
                        false,
                        'Nivel de Logro'
                      ),
                    })
                  "
                  :text_button="``"
                  :click_button="
                    () =>
                      $bvModal.show(
                        `edit-rubric_preset_unit-modal-${rubric_preset_unit.id}`
                      )
                  "
                  :icon="'square'"
                >
                </ButtonSmall>
                <ButtonSmall
                  :tooltip_text="
                    $t('reusable.common.deleteTooltip', {
                      entity: $getVisibleNames(
                        'evaluations.observationachievement',
                        false,
                        'Nivel de Logro'
                      ),
                    })
                  "
                  :text_button="``"
                  :click_button="
                    () => askForDeleteRubricPresetUnit(rubric_preset_unit.id)
                  "
                  :icon="'trash'"
                >
                </ButtonSmall>
              </div>
              <b-modal
                :id="`edit-rubric_preset_unit-modal-${rubric_preset_unit.id}`"
                :title="
                  $t('reusable.common.editModalTitle', {
                    entity: $getVisibleNames(
                      'evaluations.observationachievement',
                      false,
                      'Niveles de Logro'
                    ),
                  })
                "
                size="lg"
                hide-footer
              >
                <RubricPresetUnitForm
                  :RubricPreset="RubricPreset"
                  :RubricPresetUnit="rubric_preset_unit"
                  @updated="slotUpdatedRubricPresetUnit"
                ></RubricPresetUnitForm>
              </b-modal>
            </b-td>
          </b-tr>
        </template>
      </b-tbody>
      <template v-if="rubricPresetList.length == 0">
        <tbody>
          <tr>
            <td :colspan="allows_crud ? 4 : 2">
              {{ $t("reusable.common.noData") }}
            </td>
          </tr>
        </tbody>
      </template>
    </b-table-simple>
    <b-modal
      :id="`created-rubric_preset_unit-modal-${RubricPreset.id}`"
      :title="
        $t('reusable.common.createModalTitle', {
          entity: $getVisibleNames(
            'evaluations.observationachievement',
            false,
            'Niveles de Logro'
          ),
        })
      "
      size="md"
      hide-footer
    >
      <RubricPresetUnitForm
        :RubricPreset="RubricPreset"
        @created="
          $bvModal.hide(`created-rubric_preset_unit-modal-${RubricPreset.id}`)
        "
      ></RubricPresetUnitForm>
    </b-modal>
  </div>
</template>

<script>
import { toast } from "@/utils/utils";
import * as names from "@/store/names";
import { mapGetters } from "vuex";
export default {
  name: "RubricPresetUnit",
  components: {
    RubricPresetUnitForm: () =>
      import(
        "@/components/new-evaluations/Rubrics/RubricsPreset/RubricPresetUnitForm"
      ),
    ButtonSmall: () =>
      import("@/components/reusable/Buttons/Small/ButtonSmall"),
    RenderVHtml: () => import("@/components/reusable/RenderVHtml"),
  },
  props: {
    RubricPreset: {
      type: Object,
      required: true,
    },
    allows_crud: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      rubric_preset_units: names.RUBRIC_PRESET_UNITS,
    }),
    rubricPresetList() {
      return [
        ...this.rubric_preset_units.filter(
          (x) => this.RubricPreset.id == x.rubric_preset
        ),
      ].sort((a, b) => b.score - a.score);
    },
  },
  methods: {
    slotUpdatedRubricPresetUnit(rubric_preset_unit) {
      this.$bvModal.hide(
        `edit-rubric_preset_unit-modal-${rubric_preset_unit.id}`
      );
    },
    askForDeleteRubricPresetUnit(rubric_preset_unit_id) {
      this.$swal({
        title: this.$t("reusable.common.deleteConfirmTitle", {
          entity: this.$getVisibleNames(
            "evaluations.observationachievement",
            false,
            "Niveles de Logro"
          ),
        }),
        text: this.$t("reusable.common.deleteConfirmText"),
        type: "warning",
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch(names.DELETE_RUBRIC_PRESET_UNIT, rubric_preset_unit_id)
            .then(() => {
              toast(
                this.$t("reusable.common.deletedSuccessfully", {
                  entity: this.$getVisibleNames(
                    "evaluations.observationachievement",
                    false,
                    "Niveles de Logro"
                  ),
                })
              );
            });
        }
      });
    },
  },
  created() {},
};
</script>

<style scoped>
td,
table {
  padding: 0;
  width: -webkit-fill-available;
}
th {
  padding: 0;
  background: var(--kl-color-accent-medium) !important;
  color: var(--kl-text-on-primary);
  font-weight: var(--kl-fw-bold);
  text-align: center !important;
}
</style>